module.exports = __webpack_public_path__ + "img/icon_video_play@3x.0e2b7b29.png";